<!--Navbar-->
<mdb-navbar SideClass="navbar navbar-expand-lg navbar-light modern-navbar fixed-top" [containerInside]="false">

  <!-- Navbar brand -->
  <mdb-navbar-brand class="brand-container">
    <img [src]="logo" class="company-logo" alt="Company Logo" />
  </mdb-navbar-brand>

  <!-- Collapsible content -->
  <links>
    <!-- Links -->
    <ul class="navbar-nav ml-auto modern-nav-links" id="aln">
      <li class="nav-item">
        <a class="nav-link waves-light" [routerLink]="'/home'" routerLinkActive="active" mdbWavesEffect>
          <span class="nav-text">Home</span>
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link waves-light" [routerLink]="'/aboutus'" routerLinkActive="active" mdbWavesEffect>
          <span class="nav-text">About Us</span>
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link waves-light" [routerLink]="'/login'" routerLinkActive="active" mdbWavesEffect>
          <span class="nav-text">Login</span>
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link waves-light" href="https://www.kanbiosys.com/contact-us/" target="_blank" rel="noopener noreferrer" mdbWavesEffect>
          <span class="nav-text">Contact Us</span>
        </a>
      </li>
    </ul>
    <!-- Links -->
  </links>
  <!-- Collapsible content -->
</mdb-navbar>
<!--/.Navbar-->